module.exports = __webpack_public_path__ + "SamsungOne-500.6f4f88a3855d4998a6c7.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-500.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-500.ttf
// module chunks = styles